/**
 * La galerie suit le coloris choisi dans le calculateur.
 *
 * CE QUE LOHAN DEMANDE
 * --------------------
 * A l'arrivee sur la fiche : uniquement les photos de presentation. Aucune
 * image de coloris, pas meme celle du blanc, qui ouvrait la galerie sur un
 * a-plat sans interet.
 * Des qu'un coloris est choisi : la page remonte, et les deux premieres
 * vignettes deviennent la face avant puis la face arriere de ce coloris.
 *
 * POURQUOI CE N'EST PAS FAIT EN LIQUID
 * ------------------------------------
 * Shopify n'accepte qu'UNE image par variante. Impossible d'y declarer une
 * paire avant/arriere. Le rattachement se fait donc ici, a partir du nom de
 * fichier — ou du texte alternatif s'il porte la meme convention, ce qui
 * permet de rattraper un fichier mal nomme sans le reimporter.
 *
 * LA CONVENTION
 * -------------
 * Le nom doit contenir le numero du coloris et la face :
 *
 *   190_REGULAR_FRONT_Pantone_01.png   ->  coloris 01, face avant
 *   190_REGULAR_BACK_Pantone_01.png    ->  coloris 01, face arriere
 *
 * L'ordre des morceaux est libre, la casse indifferente, et le suffixe que
 * Shopify ajoute en cas de doublon de nom ne gene pas. Une image qui ne
 * repond pas a ce motif est une photo de presentation : elle reste visible en
 * permanence.
 *
 * Si un coloris n'a qu'une seule face, elle s'affiche seule. Rien ne casse.
 */
(function () {
  'use strict';

  var MOTIF_COULEUR = /pantone[\s_-]*0*(\d{1,2})/i;
  var MOTIF_AVANT = /(^|[\s_-])(front|face|recto|av)([\s_-]|$)/i;
  var MOTIF_ARRIERE = /(^|[\s_-])(back|dos|arriere|rear|verso|ar)([\s_-]|$)/i;

  function classe(texte) {
    if (!texte) return null;
    var c = MOTIF_COULEUR.exec(texte);
    if (!c) return null;
    var face = MOTIF_ARRIERE.test(texte) ? 'back' : (MOTIF_AVANT.test(texte) ? 'front' : null);
    if (!face) return null;
    // « 1 » et « 01 » designent le meme coloris.
    return { couleur: String(parseInt(c[1], 10)), face: face };
  }

  function Galerie(racine) {
    this.grille = racine.querySelector('.product-gallery-grid');
    if (!this.grille) return;

    this.paires = {};
    this.affichees = [];

    var self = this;
    this.grille.querySelectorAll('.product-gallery-grid__item').forEach(function (item) {
      var info = classe(item.dataset.lineryAlt) || classe(item.dataset.lineryFile);
      if (!info) return;                       // photo de presentation
      item.hidden = true;
      item.dataset.lineryColor = info.couleur;
      item.dataset.lineryFace = info.face;
      var p = self.paires[info.couleur] || (self.paires[info.couleur] = {});
      // Le premier trouve gagne : si deux fichiers revendiquent la meme face,
      // c'est l'ordre de la galerie Shopify qui tranche.
      if (!p[info.face]) p[info.face] = item;
    });

    this.actif = Object.keys(this.paires).length > 0;
    if (!this.actif) return;

    // Le calculateur emet plusieurs evenements silencieux au montage : chaque
    // appel de selectGsm rappelle selectColor avec silent = true pour annoncer
    // le coloris par defaut. La galerie les ignore tous. Lohan veut une fiche
    // qui s'ouvre sans aucune image de coloris ; le garde precedent ne
    // neutralisait que le tout premier evenement, et le second remettait la
    // face avant du 01 en premiere position — l'a-plat blanc qu'on cherchait
    // justement a supprimer.
    //
    // Des que l'utilisateur a choisi un coloris, les evenements silencieux
    // redeviennent utiles : changer de grammage rappelle selectColor en
    // silencieux, et la paire affichee doit suivre sans faire sauter la page.
    this.interaction = false;

    document.addEventListener('linery:color:changed', function (e) {
      var detail = e.detail || {};
      if (!detail.silent) self.interaction = true;
      if (!self.interaction) return;
      self.montrer(detail);
    });
  }

  Galerie.prototype.montrer = function (detail) {
    var code = detail.code;
    if (!code) {
      var m = String(detail.value || '').match(/(\d{1,2})/);
      code = m ? m[1] : null;
    }
    if (!code) return;
    code = String(parseInt(code, 10));

    var paire = this.paires[code];
    if (!paire) return;                        // coloris sans photo : on ne touche a rien

    this.affichees.forEach(function (n) { n.hidden = true; });
    this.affichees = [];

    // On insere l'arriere d'abord, puis l'avant devant lui : l'avant se
    // retrouve en premiere position, l'arriere en deuxieme.
    var ordre = [paire.back, paire.front];
    for (var i = 0; i < ordre.length; i++) {
      var n = ordre[i];
      if (!n) continue;
      n.hidden = false;
      this.grille.insertBefore(n, this.grille.firstChild);
      this.affichees.push(n);
    }

    if (!detail.silent) this.remonter();
  };

  // Demande de Lohan, 14/09 : on remonte tout en haut de la page, en-tete et
  // fil d'Ariane compris, pas au niveau de la galerie. La version precedente
  // calait la galerie sous l'en-tete collant, ce qui faisait disparaitre le
  // titre du produit.
  Galerie.prototype.remonter = function () {
    var doux = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: doux ? 'smooth' : 'auto' });
  };

  function demarrer() {
    document.querySelectorAll('.product-media').forEach(function (n) { new Galerie(n); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
